import { ContactLookupSettings } from "@signalist/shared-types";

import { FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";

import { CreditConfirmModal } from "@/components/CreditConfirmModal";

import { previewQuote } from "./previewQuoteSegments";

interface PreviewCreditConfirmProps {
	companyCount: number;
	/** The list's contact lookup settings, which the preview runs like a list run does. */
	contactLookups: ContactLookupSettings;
	onClose: () => void;
	/** Starts the preview; rejects when the API refuses it. */
	onConfirm: () => Promise<unknown>;
}

/**
 * The credit-confirm of Start Preview (PREC-4263): the companies the preview searches and the
 * lookups the list's settings add, each at its shared price and decided by what the run finds,
 * and the credits the API checks the balance against before it starts (review M2: that check was
 * shown as the preview's total, while a preview with phone lookups costs 10 per lookup on top).
 */
export const PreviewCreditConfirm: FunctionComponent<PreviewCreditConfirmProps> = ({
	companyCount,
	contactLookups,
	onClose,
	onConfirm,
}) => {
	const { t } = useTranslation();
	const count = companyCount;
	const { segments, requiredToStart } = previewQuote(count, contactLookups, t);

	return (
		<CreditConfirmModal
			isOpened
			body={
				<Trans
					components={{ b: <b className="font-semibold" /> }}
					i18nKey="creditConfirm.preview.body"
					values={{ count }}
				/>
			}
			chargeNote={t("creditConfirm.preview.chargeNote")}
			confirmLabel={t("creditConfirm.preview.confirm", { count })}
			requiredToStart={requiredToStart}
			segments={segments}
			title={t("creditConfirm.preview.title")}
			onClose={onClose}
			onConfirm={onConfirm}
		/>
	);
};
